<template>
  <v-container style="max-width: 800px;">
    <v-btn text class="mb-4" @click="$router.back()">
      <v-icon left>mdi-arrow-left</v-icon>
      戻る
    </v-btn>
    <h1 class="text-h5 font-weight-bold mb-6">プライバシーポリシー</h1>
    <div class="body-1">
      <p>
        資格管理アプリ（以下「当サイト」といいます）は、当サイトの運営するサービス（以下「サービス」といいます）について、サービスの提供を受ける利用者（以下「カスタマー」といいます）の個人情報の保護を目的として、プライバシーポリシー（以下「本ポリシー」といいます）を定めます。
      </p>

      <h2 class="text-h6 font-weight-bold mt-6 mb-3">第1条（個人情報）</h2>
      <p>
        「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、連絡先その他の記述等により特定の個人を識別できる情報及び容貌、指紋、声紋にかかるデータ、及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。
      </p>

      <h2 class="text-h6 font-weight-bold mt-6 mb-3">第2条（個人情報の収集方法）</h2>
      <p>
        当サイトは、Googleアカウントによる認証を通じてサービスを提供しており、以下の情報を取得します。
      </p>
      <ul class="mb-3">
        <li>Googleアカウントのユーザー名・メールアドレス</li>
        <li>サービス利用にあたりカスタマーが入力した資格情報</li>
      </ul>

      <h2 class="text-h6 font-weight-bold mt-6 mb-3">第3条（個人情報を収集・利用する目的）</h2>
      <p>当サイトが個人情報を収集・利用する目的は以下のとおりです。</p>
      <ol class="mb-3">
        <li>当サイトのサービスの提供・運営のため</li>
        <li>カスタマーからのお問い合わせに回答するため</li>
        <li>サービスの改善・新機能の開発のため</li>
        <li>利用規約に違反したカスタマーへの対応のため</li>
      </ol>

      <h2 class="text-h6 font-weight-bold mt-6 mb-3">第4条（第三者への提供）</h2>
      <p>
        当サイトは、次に掲げる場合を除いて、あらかじめカスタマーの同意を得ることなく、第三者に個人情報を提供することはありません。
      </p>
      <ol class="mb-3">
        <li>法令に基づく場合</li>
        <li>人の生命、身体または財産の保護のために必要がある場合</li>
        <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</li>
      </ol>

      <h2 class="text-h6 font-weight-bold mt-6 mb-3">第5条（個人情報の開示）</h2>
      <p>
        当サイトは、カスタマーから個人情報の開示を求められたときは、カスタマーに対し、遅滞なくこれを開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。
      </p>

      <h2 class="text-h6 font-weight-bold mt-6 mb-3">第6条（個人情報の訂正および削除）</h2>
      <p>
        カスタマーは、当サイトの保有する自己の個人情報が誤った情報である場合には、当サイトが定める手続きにより、個人情報の訂正、追加または削除（以下、「訂正等」といいます。）を請求することができます。
      </p>

      <h2 class="text-h6 font-weight-bold mt-6 mb-3">第7条（Cookieの使用）</h2>
      <p>
        当サイトは、Googleアナリティクスを利用しています。Googleアナリティクスはトラフィックデータの収集のためにCookieを使用しています。このデータは匿名で収集されており、個人を特定するものではありません。
      </p>

      <h2 class="text-h6 font-weight-bold mt-6 mb-3">第8条（プライバシーポリシーの変更）</h2>
      <p>
        本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、カスタマーに通知することなく変更することができるものとします。
      </p>

      <p class="mt-8 grey--text">制定日：2023年11月</p>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'Privacy',
}
</script>
